module.exports = __webpack_public_path__ + "img/lk-hero-img-side.d72bca07.svg";